// extracted by mini-css-extract-plugin
export var linkText = "_oo-0";